import { render, staticRenderFns } from "./sf_form.vue?vue&type=template&id=52275cf4&"
import script from "./sf_form.vue?vue&type=script&lang=js&"
export * from "./sf_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports